import { upload_file } from '@/commons/hpod';
import { sendErrorNotice, refreshResource } from '@/commons/utils';
import Crud from './crud'
import Vue from 'vue';
var crud = new Crud('voucher-customer', 'mã giảm giá');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        UID: 0,
        VoucherID: 0,
        Status: 0,
        Qty: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    import_excel({ commit }, formData) {
        commit("setLoading", { loading: true });
        upload_file(crud.endpoint, res => {
            commit("setLoading", { loading: false });
            if(res.status == 202) {
                sendErrorNotice(res.data.reason)
            }
            else {
                refreshResource();
            }
            
        }, Vue.http, formData, this.state.authentication.token, 'import');
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};